<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      enableCellTextSelection="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [getContextMenuItems]="getContextMenuItems"
      [getMainMenuItems]="getMainMenuItems"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      (columnMoved)="onColumnMoved($event)"
      (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)"
      (rowSelected)="onRowSelected()"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #copyModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test summary</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex modal-tabs-vertical">
      <ul class="nav flex-column">
        <div *ngFor="let section of testCaseDetails" (click)="scrollTo(section.id)">
          <a class="nav-link cp" [ngClass]="{ active: currentSection === section.id }">
            <span class="nav-text"> {{ section.title }}</span>
          </a>
        </div>
      </ul>

      <div class="tab-content section-parent" id="parentDiv" scrollSpy [spiedTags]="['DIV']" (sectionChange)="onSectionChange($event)">
        <div *ngFor="let section of testCaseDetails" [id]="section.id" class="section-child">
          <ul class="modal-tab-list modal-tab-table-list">
            <li class="title">{{ section.title }}</li>
            <li *ngFor="let details of section.data">
              <span class="left-col">{{ details[0] }}</span>
              <span class="right-col">{{ details[1] }}</span>
            </li>
            <li *ngIf="section.id === 'smpp'" class="note">
              <span
                >Please note that the logic used to decode the PDU here can’t be guaranteed to be exactly the same logic used by the end device to
                retrieve the individual SMS parameters displayed to the end user, such as Sender ID and Text.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
    </div>
  </div>
</ng-template>

<ng-template #cliModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3 class="d-inline-block">Caller ID sent/Caller ID delivered</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="two-col-box">
      <ul>
        <li>
          <span class="left-col text-neutral-n7">{{ callerDifference?.title1 }}</span>
          <span class="right-col" [innerHTML]="callerDifference?.value1"></span>
        </li>
        <li>
          <span class="left-col text-neutral-n7">{{ callerDifference?.title2 }}</span>
          <span class="right-col" [innerHtml]="callerDifference?.value2"></span>
        </li>
      </ul>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-start align-items-center bg-neutral-n2">
    <div class="view-summary cp" (click)="dialogRef.close('viewSummary')">
      <span>View test summary <i class="fas fa-chevron-right ps-0_5"></i></span>
    </div>
  </div>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header">
    <button aria-label="Close" class="close" type="button" (click)="dialogRef.close(true)">
      <span aria-hidden="true">×</span>
    </button>
    <h3 class="modal-title">Comment</h3>
  </div>
  <div class="modal-body">
    <app-test-result-comment [model]="commentModel"></app-test-result-comment>
  </div>
</ng-template>

<app-phone-report-widget></app-phone-report-widget>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>
